module.exports = __webpack_public_path__ + "static/media/dina_secure.ba92c559.png";